/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Response } from '../api-models';
// @ts-ignore
import { SyncEmployeeResponse } from '../api-models';
// @ts-ignore
import { SyncFacilityResponse } from '../api-models';
/**
 * ProfileManagementApi - axios parameter creator
 * @export
 */
export const ProfileManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Enqueue jobs to sync all profiles in all facilities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProfileManagementBulkEnqueueSyncAllFacilitiesPut: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/profile-management/bulk/enqueue-sync-all-facilities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync all profiles for a specific facility
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProfileManagementBulkSyncFacilityFacilityIdPut: async (facilityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminProfileManagementBulkSyncFacilityFacilityIdPut', 'facilityId', facilityId)
            const localVarPath = `/admin/profile-management/bulk/sync-facility/{facilityId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync the profile for a specific employee
         * @param {string} facilityId 
         * @param {number} pkEmployeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProfileManagementSyncEmployeeFacilityIdPkEmployeeIdPut: async (facilityId: string, pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminProfileManagementSyncEmployeeFacilityIdPkEmployeeIdPut', 'facilityId', facilityId)
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('adminProfileManagementSyncEmployeeFacilityIdPkEmployeeIdPut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/admin/profile-management/sync-employee/{facilityId}/{pkEmployeeId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileManagementApi - functional programming interface
 * @export
 */
export const ProfileManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfileManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Enqueue jobs to sync all profiles in all facilities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProfileManagementBulkEnqueueSyncAllFacilitiesPut(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProfileManagementBulkEnqueueSyncAllFacilitiesPut(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync all profiles for a specific facility
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProfileManagementBulkSyncFacilityFacilityIdPut(facilityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncFacilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProfileManagementBulkSyncFacilityFacilityIdPut(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync the profile for a specific employee
         * @param {string} facilityId 
         * @param {number} pkEmployeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProfileManagementSyncEmployeeFacilityIdPkEmployeeIdPut(facilityId: string, pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncEmployeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProfileManagementSyncEmployeeFacilityIdPkEmployeeIdPut(facilityId, pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProfileManagementApi - factory interface
 * @export
 */
export const ProfileManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfileManagementApiFp(configuration)
    return {
        /**
         * 
         * @summary Enqueue jobs to sync all profiles in all facilities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProfileManagementBulkEnqueueSyncAllFacilitiesPut(options?: AxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.adminProfileManagementBulkEnqueueSyncAllFacilitiesPut(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync all profiles for a specific facility
         * @param {ProfileManagementApiAdminProfileManagementBulkSyncFacilityFacilityIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProfileManagementBulkSyncFacilityFacilityIdPut(requestParameters: ProfileManagementApiAdminProfileManagementBulkSyncFacilityFacilityIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<SyncFacilityResponse> {
            return localVarFp.adminProfileManagementBulkSyncFacilityFacilityIdPut(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync the profile for a specific employee
         * @param {ProfileManagementApiAdminProfileManagementSyncEmployeeFacilityIdPkEmployeeIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProfileManagementSyncEmployeeFacilityIdPkEmployeeIdPut(requestParameters: ProfileManagementApiAdminProfileManagementSyncEmployeeFacilityIdPkEmployeeIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<SyncEmployeeResponse> {
            return localVarFp.adminProfileManagementSyncEmployeeFacilityIdPkEmployeeIdPut(requestParameters.facilityId, requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminProfileManagementBulkSyncFacilityFacilityIdPut operation in ProfileManagementApi.
 * @export
 * @interface ProfileManagementApiAdminProfileManagementBulkSyncFacilityFacilityIdPutRequest
 */
export interface ProfileManagementApiAdminProfileManagementBulkSyncFacilityFacilityIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfileManagementApiAdminProfileManagementBulkSyncFacilityFacilityIdPut
     */
    readonly facilityId: string
}

/**
 * Request parameters for adminProfileManagementSyncEmployeeFacilityIdPkEmployeeIdPut operation in ProfileManagementApi.
 * @export
 * @interface ProfileManagementApiAdminProfileManagementSyncEmployeeFacilityIdPkEmployeeIdPutRequest
 */
export interface ProfileManagementApiAdminProfileManagementSyncEmployeeFacilityIdPkEmployeeIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfileManagementApiAdminProfileManagementSyncEmployeeFacilityIdPkEmployeeIdPut
     */
    readonly facilityId: string

    /**
     * 
     * @type {number}
     * @memberof ProfileManagementApiAdminProfileManagementSyncEmployeeFacilityIdPkEmployeeIdPut
     */
    readonly pkEmployeeId: number
}

/**
 * ProfileManagementApi - object-oriented interface
 * @export
 * @class ProfileManagementApi
 * @extends {BaseAPI}
 */
export class ProfileManagementApi extends BaseAPI {
    /**
     * 
     * @summary Enqueue jobs to sync all profiles in all facilities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileManagementApi
     */
    public adminProfileManagementBulkEnqueueSyncAllFacilitiesPut(options?: AxiosRequestConfig) {
        return ProfileManagementApiFp(this.configuration).adminProfileManagementBulkEnqueueSyncAllFacilitiesPut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync all profiles for a specific facility
     * @param {ProfileManagementApiAdminProfileManagementBulkSyncFacilityFacilityIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileManagementApi
     */
    public adminProfileManagementBulkSyncFacilityFacilityIdPut(requestParameters: ProfileManagementApiAdminProfileManagementBulkSyncFacilityFacilityIdPutRequest, options?: AxiosRequestConfig) {
        return ProfileManagementApiFp(this.configuration).adminProfileManagementBulkSyncFacilityFacilityIdPut(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync the profile for a specific employee
     * @param {ProfileManagementApiAdminProfileManagementSyncEmployeeFacilityIdPkEmployeeIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileManagementApi
     */
    public adminProfileManagementSyncEmployeeFacilityIdPkEmployeeIdPut(requestParameters: ProfileManagementApiAdminProfileManagementSyncEmployeeFacilityIdPkEmployeeIdPutRequest, options?: AxiosRequestConfig) {
        return ProfileManagementApiFp(this.configuration).adminProfileManagementSyncEmployeeFacilityIdPkEmployeeIdPut(requestParameters.facilityId, requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }
}
